
"use strict"; // jshint ignore:line

import {
    Light,
    HemisphereLight,
    Box3,
    CubeCamera,
    WebGLRenderer,
    LinearFilter,
    RGBFormat,
    WebGLCubeRenderTarget
} from '../../../src/js/three.module.js';

import { Painting }          from '../classes/painting.js';
import { Statue }            from '../classes/statue.js';
import Helpers               from '../classes/Helpers.js';
import { GameSceneRenderer } from '../classes/game-scene-renderer.js';

import { createHemisphereGroundColor } from '../../utils/colors.js';

export function GameSceneService( $rootScope,  $timeout,  $state,  $q,  additionalObjectService,  $oeuvresHandler,  contextMenuService, wallsHandlerService, dragHandlesService, ArrangementService, spherical360SetupService, $location, gettextCatalog ) {
    
    GameSceneService.getInstance = () => this;

    let gameService, self = gameService = window.gameService = $rootScope.gameService = this;
    
    var $readyPromise = $q.defer();
    this.$ready = $readyPromise.promise;

    this.opts = {};

    var scene  = window.scene =  this.scene   = null;
    var player = window.player = this.player  = null;
    window.oeuvres = this.oeuvres = $oeuvresHandler.oeuvres;

    this.lights = [];

    this.$fpsHistory = [];
    this.FPS = NaN;

    /*****/

    var isInEditor = false;

    this.inEditor = function() {
        return isInEditor;
    };

    Object.defineProperty( this, "editor", {
        get: function() {

            return isInEditor;

        },
        set: function( _isInEditor ) {

            /** JOS ollaan puhtaassa katselunäkymässä, ei editoria edes voi avata! */
            if (window.MODEL_VIEWER) _isInEditor = null;

            if (isInEditor == _isInEditor) return;
            
            isInEditor = !!_isInEditor;

            if (_isInEditor) {

                $rootScope.$broadcast( "editorEnabled" );

            } else {

                $rootScope.$broadcast( "editorDisabled" );

            }
        }
    });

    this.editor = false;
    
    /****/

    var inControlMode = false;

    Object.defineProperty( this, "inControlMode", {
        set: function( _inControlMode ) {

            if (!isInEditor) _inControlMode = null;

            if (inControlMode == _inControlMode) return;

            inControlMode = !!_inControlMode;

            gameService.renderNeeded = true;

            try {

                if (player) {
                    player.floorObj.visible = inControlMode;
                }

    //			if (HUDService.transformCtrl) HUDService.transformCtrl.visible = visible && !!HUDService.transformCtrl.object;
        
                for (var i in additionalObjectService.objects) {

                    var obj = additionalObjectService.objects[i];

                    switch (obj.type) {
                        case "light":
                            obj.wireframe.visible = inControlMode
                            break;
                    }
                }

            } catch(e) {
                console.error(e);
            }
            
            $rootScope.$broadcast( "onControlModeVisibilityChanged", inControlMode );
        },
        get: function() {
            return inControlMode;
        }
    });

    this.inControlMode = false;

    this.setControlModeVisibility = function setControlModeVisibility( visible ) {
        this.inControlMode = visible;
    }

    /****/

    this.renderNeeded = true;
    this.forceRender  = false;

    /****/

    this.shadowsNeedsUpdate = null;

    $rootScope.$on( "onAfterUserAct", function(){
        self.shadowsNeedsUpdate = true;
    });

    /*****/
    
    $rootScope.$on( "spherical360SetupServiceEnabled", function() {
        self.scene.add( spherical360SetupService );
    });

    $rootScope.$on( "spherical360SetupServiceDisabled", function() {
        self.scene.remove( spherical360SetupService );
    });

    /*****/

    window.helpers && window.helpers.clear();

    this.init = function( sceneStuff, arrangement ){

        this.opts = {
            helpers:      arrangement.$config.helpers      || {},
            wallsHandler: arrangement.$config.wallsHandler || {},
            oeuvres:      arrangement.$config.oeuvres      || {},
            game:         arrangement.$config.game         || {}
        };

        this.opts.oeuvres.fixedBtmOffset = this.opts.oeuvres.fixedBtmOffset || 0.05;

        /**************************/

        this.arrangement = $rootScope.arrangement = arrangement;
        this.scene       = window.scene = scene       = $rootScope.scene = sceneStuff.scene;
        this.player      = window.player = player      = $rootScope.player;
        this.helpers     = window.helpers     = new Helpers( this.opts.helpers );
        this.worldModel  = worldModel;


        if (arrangement.$config.type == "spherical360") {
            spherical360SetupService.enable();
        }


        // Kun ollaan puhtaasti pelkässä katselutilassa, otetaan Helpers pois käytöstä
        if (window.MODEL_VIEWER) {
            helpers.disabled = true;
        }

        try {
            this.$worldBox = ( new Box3() ).setFromObject( worldModel );
        } catch (error) {
            console.error( error );
        }

        this.scene.add( this.player.floorObj );

        wallsHandlerService.init( oeuvres, this.opts.wallsHandler );

        if (!this.arrangement.$editable) this.editor = false;

        try {
            additionalObjectService.setObjectTemplates( arrangement.$model.config.additional_objects );
        } catch (err) { console.error( err ); }

        try {
            /** Kovakoodattuja vakiomallisia templateja */
            var static_templates = {
                ...GameSceneService.additionalObjectService_defaultTemplates
            };

            for (var key in static_templates) {
                var template = additionalObjectService.setObjectTemplate( key, static_templates[key] )
            }
        } catch (err) { console.error( err ); }

        /** Parsitaan selville mallissa mahdollisesti olevat valot ja sijoitetaan ne tietoon s.e. ovat muokattavana AdditionalObject'n kautta */
        this.lights = worldModel.children.filter(function( child ) {

            return child instanceof Light;

        }).map(function( child ) {

            try {
                var obj = new AdditionalObject.Light( child );
                obj.$fromModel = true;
                obj.isRemoveable = false;
                return obj.mesh;
            } catch (err) { console.error( err ); }

            return child;
        });

        this.worldLight = new AdditionalObject.Light( new HemisphereLight( 0xffffff, createHemisphereGroundColor( 0xffffff ), 0.3 ));
        this.worldLight.$worldLight = true;
        this.worldLight.isRemoveable = false;

        this.worldLight.title = gettextCatalog.getString( "Default ambient light" );

        scene.add( this.worldLight.mesh );
        scene.add( this.player.light );
        scene.add( helpers );
        scene.add( dragHandlesService.handles );

        return $timeout(function(){
            if( !$rootScope.scene ) throw new Error("Scene not available");

            $readyPromise.resolve();
        });
    };

    /*********************/

    this.renderer = null;

    this.genRenderer = function( parameters_overwrite = null, performance_level = null ) {

        if (!performance_level) performance_level = GameSceneRenderer.solvePerformanceLevel();

        let parameters = GameSceneRenderer.buildParameters( parameters_overwrite, performance_level );

        var renderer = new WebGLRenderer( parameters );

        angular.extend( renderer.shadowMap, parameters.shadowMap );

        renderer.setPixelRatio( window.devicePixelRatio );

        return renderer;
    }

    this.setRenderer = function( parameters_overwrite = null, performance_level = null ) {

        self.renderer = self.genRenderer( parameters_overwrite, performance_level );

        return self.renderer;
    };

    /*********************/

    this.save = function( arrangement ){
        return ArrangementService.saveArrangement( arrangement = arrangement || this.arrangement )
        .then(function( arrangement ){
            arrangement.updated_at = new Date();
            if( arrangement.uid && $state.params.arrangement_uid != arrangement.uid ){
                $location.search( "arrangement_uid", arrangement.uid );
                $state.go("scene", {
                    "arrangement_uid": arrangement.uid
                }, {
                    notify: false
                }).then(function(){
                    return $state.go("scene", {
                        "arrangement_uid": arrangement.uid
                    }, {
                        reload: true
                    });
                });
            }
            return arrangement;
        });
    };

    /*********************/

    this.addPainting = function( oeuvre ){
        contextMenuService.init( "preview-oeuvre-"+oeuvre.uid, "templates/context-modals/oeuvres.html", {
            oeuvre: oeuvre
        });
        this.scene.add( oeuvre.mesh );
    };
    this.addStatue = function( oeuvre ){
        contextMenuService.init( "preview-oeuvre-"+oeuvre.uid, "templates/context-modals/oeuvres.html", {
            oeuvre: oeuvre
        });
        this.scene.add( oeuvre.mesh );
    };
    this.addOeuvre = function( oeuvre ){
        if( oeuvre instanceof Painting ) return this.addPainting( oeuvre );
        if( oeuvre instanceof Statue   ) return this.addStatue( oeuvre );

        console.warn( "gameSceneService :: Failed to add, instanceof unknown" );
    };
    this.rmOeuvre = function( oeuvre ){
        $oeuvresHandler.rmOeuvre( oeuvre );
        contextMenuService.remove( "preview-oeuvre-"+oeuvre.uid );
        this.scene.remove( oeuvre.mesh );
    }

    /********/
    this.getScreenshot = function(){
        return $q(function( resolve, reject ){
            try {
                var img = new Image();
                img.onload = function(){ resolve( img ); }
                self.renderer.render( self.scene, self.player.camera );
                img.src = self.renderer.context.canvas.toDataURL( "png" );
            } catch( error ){
                reject( error );
            }
        });
    };

    /**
     * @see https://github.com/spite/THREE.CubemapToEquirectangular
     */
    this.getEquirectangularScreenshot = (function( equi, renderer, cubeCamera ) {

        return function() {

            return $q.when( equi || $q.when( window.CubemapToEquirectangular || $.getScript( "js/objects/CubemapToEquirectangular.js" )).then(function() {

                let CubemapToEquirectangular = window.CubemapToEquirectangular;

                renderer   = gameService.genRenderer(); //new THREE.WebGLRenderer();

                let renderTargetOptions = { format: RGBFormat, magFilter: LinearFilter, minFilter: LinearFilter };
                let renderTargetResolution = 4096;
                let renderTarget = new WebGLCubeRenderTarget( renderTargetResolution, renderTargetOptions );

                cubeCamera = new CubeCamera( player.camera.near, player.camera.far, renderTarget );
                equi       = new CubemapToEquirectangular( renderer, false );

            })).then(function() {

                cubeCamera.position.copy( player.headPos );
                cubeCamera.update( renderer, gameService.scene );

                var imageData = equi.convert( cubeCamera, false );

                equi.ctx.putImageData( imageData, 0, 0 );

                return $q(function( resolve, reject ) {

                    equi.canvas.toBlob( function( blob ) {

                        resolve({ src: URL.createObjectURL( blob ) });

                        return;
                        /*
                        var img = new Image();

                        img.onload  = function() { resolve( img ); };
                        img.onerror = reject;

                        img.src = URL.createObjectURL( blob );
                        */
                    }, "image/png" );
                });
            });
        };
    })();
}

GameSceneService.additionalObjectService_defaultTemplates = {
    "human_1_json": {
        title      : "Ihmishahmo",
        type       : "json",
        source     : "url",
        source_url : "media/models/human.json",
        availPlanes: {
            floor   : true,
            wall    : false,
            ceiling : false
        }
    },
    "chair_1_json": {
        title      : "Tuoli",
        type       : "json",
        source     : "url",
        source_url : "media/models/chair.json",
        availPlanes: {
            floor   : true,
            wall    : false,
            ceiling : false
        }
    }
};


GameSceneService.$inject = [ "$rootScope","$timeout","$state","$q","additionalObjectService","$oeuvresHandler","contextMenuService", "wallsHandlerService", "dragHandlesService", "ArrangementService", "spherical360SetupService", "$location", "gettextCatalog" ];